module.exports = __webpack_public_path__ + "static/media/PL.9643cb39.png";